import styled, { useTheme } from "styled-components";
import { motion } from "framer-motion";
import { Theme } from "../../models/theme";
import { buttonWhileHover, buttonWhileTap } from "../../styles/animations";
import { useMedia } from "react-use";

interface MenuButtonProps {
  onClick: () => any;
  open: boolean;
}

const Button = styled(motion.button)`
  padding: 0;
  background-color: transparent;
  outline: none;
  border: none;
  cursor: pointer;
`;

const CircleClosed = styled(motion.circle)`
  fill: ${({ theme }) => theme.colors.hotPink};
`;

const CircleOpen = styled(motion.circle)`
  fill: ${({ theme }) => theme.colors.white};
`;

const Path = (props: any) => (
  <motion.path
    fill="transparent"
    strokeWidth="2"
    strokeLinecap="round"
    {...props}
  />
);

const Svg = styled(motion.svg)`
  vertical-align: middle;
`;

export const MenuButton: React.FC<MenuButtonProps> = ({
  onClick,
  open,
  children,
}) => {
  const theme = useTheme() as Theme;
  const isWide = useMedia(`(min-width: ${theme.breakpoints[1]})`);

  return (
    <Button
      onClick={() => onClick()}
      whileHover={buttonWhileHover}
      whileTap={buttonWhileTap}
    >
      <Svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        animate={open ? "open" : "closed"}
      >
        {/* <CircleClosed
          cx="24"
          cy="24"
          r="24"
          variants={{
            closed: { opacity: 1 },
            open: { opacity: 0 },
          }}
        />
        <CircleOpen
          cx="24"
          cy="24"
          r="24"
          variants={{
            closed: { opacity: 0 },
            open: { opacity: 1 },
          }}
        /> */}
        {isWide ? (
          <>
            <CircleClosed
              cx="24"
              cy="24"
              r="24"
              variants={{
                closed: { opacity: 1 },
                open: { opacity: 0 },
              }}
            />
            <CircleOpen
              cx="24"
              cy="24"
              r="24"
              variants={{
                closed: { opacity: 0 },
                open: { opacity: 1 },
              }}
            />
          </>
        ) : (
          <CircleClosed cx="24" cy="24" r="24" />
        )}
        <Path
          stroke={theme.colors.white}
          variants={{
            closed: {
              d: "M 18 19 L 34 19",
              opacity: 1,
            },
            open: {
              d: "M 18 30 L 30 18",
              opacity: 0,
            },
          }}
        />
        <Path
          stroke={isWide ? theme.colors.blueDark : theme.colors.white}
          variants={{
            closed: { d: "M 18 19 L 34 19", opacity: 0 },
            open: {
              d: "M 18 30 L 30 18",
              opacity: 1,
            },
          }}
        />
        <Path
          d="M 14 25 L 34 25"
          stroke={theme.colors.white}
          variants={{
            closed: { opacity: 1 },
            open: { opacity: 0 },
          }}
          transition={{ duration: 0.1 }}
        />
        {/* Bottom to left of x */}
        <Path
          stroke={theme.colors.white}
          variants={{
            closed: { d: "M 20 31 L 34 31" },
            open: { d: "M 18 18 L 30 30" },
          }}
        />
        <Path
          stroke={isWide ? theme.colors.blueDark : theme.colors.white}
          variants={{
            closed: {
              d: "M 20 31 L 34 31",
              opacity: 0,
            },
            open: {
              d: "M 18 18 L 30 30",
              opacity: 1,
            },
          }}
        />
      </Svg>
    </Button>
  );
};
